import { combineReducers } from 'redux';
import auth from './authReducer';
import informationWrapper from '@revenatium/vibranium-agencies/dist/reducers/informationActions';
import documentListWrapper from '@revenatium/vibranium-agencies/dist/reducers/documentActions';
import configurationWrapper from "@revenatium/vibranium-agencies/dist/reducers/configurationAction";
import countryListWrapper from "@revenatium/vibranium-agencies/dist/reducers/CountryActions";
import accountListWrapper from "@revenatium/vibranium-agencies/dist/reducers/accountActions";
import accountWrapper from "@revenatium/vibranium-agencies/dist/reducers/accountCodeActions";

const rootReducer = combineReducers({
   auth,
   informationWrapper,
   documentListWrapper,
   configurationWrapper,
   countryListWrapper,
   accountListWrapper,
   accountWrapper
});

export default rootReducer;